import React, { Component } from 'react';
import './Reports.css'

class Reports extends Component {
    state = {  }
    render() { 
        if (this.props.children === undefined)
          return ( <p className="sc-reports-tab-init">Al momento non è stato generato alcun report. <br></br>
Fare clic su un oggetto in mappa per generare un report sulla proprietà.</p> );

        return ( <div className="sc-reports-tab-content">{this.props.children}</div> );
    }
}
 
export default Reports;